import Layers from "slotworks/graphics/layers/layers";
import Components from "slotworks/components/components";
import * as TweenJS from "slotworks/utils/tween";
import gameState from "slotworks/model/game-state";
import G288SpinRecord from "integration/spin-record";
import G288Components from "components/components";
import deviceInfo from "slotworks/utils/device-info";
import canvasManager, { Orientation } from "slotworks/graphics/canvas/canvas-manager";
import { ShakeLayers } from "commands/shake-command";

export default class AnticipationComponent {

    private reels: boolean[] = [];

    private backgroundMotion: boolean;
    private background: HTMLElement;

    private shakeTween: TweenJS.Tween = null;

    public initAnticipations() {
        this.reels = [false, false, false, false, false];
        this.hide();
        Layers.MatrixBackground.onSceneEnter.add(() => this.hide());
        Components.matrix.startSignal.add(this.resetReels);
        
        Components.matrix.landSignal.add((index: number) => {
            const record = gameState.getCurrentGame().getCurrentRecord() as G288SpinRecord;
            
            this.reels[index - 1] = true;
            if(index >= 2 && record.anticipations.reelAnticipations) {
                if(index > 2) {
                    this.stop(index);
                }
                if(index < 5 && record.anticipations.reelAnticipations && record.anticipations.reelAnticipations[index] && !this.reels[index]) {
                    this.anticipate(index + 1);
                }
            }

            // scatters
            if(record.freespinsTriggered || 
                (record.anticipations.landSymbols && 
                    record.anticipations.landSymbols[index - 1] && 
                    record.anticipations.landSymbols[index - 1].length)) {
                const reel = Components.matrix.getReels()[index - 1];
                const scatter = reel.getSymbols().find(element => element.symbolId === "SCATTER"); 
                if(scatter) {
                    const transform = scatter.getTransform();                   
                    const layer = scatter.getLayer();                                                                                           
                    const front = layer.localToLocal(Layers.Custom.get("Animations"), transform);              
                    G288Components.scatterEmitter.emit(index, front.x + transform.width/2, front.y);
                }
            }        
        });
    }

    private portrait: boolean;
    private backgroundZoomIn() {
        let orientationString;
        if(!deviceInfo.isDesktop) {
            this.portrait = canvasManager.orientation == Orientation.PORTRAIT
            orientationString = this.portrait ? "#portrait" : "#landscape";
            
        } else {
            this.portrait = false;
            orientationString = "#landscape";
        }
        this.background = document.querySelector(`${orientationString} #Background #default`) as HTMLElement;
        if(this.background) {
            if(this.portrait) {
                this.background.style.transition = "transform 6s ease-out";
                this.background.style.transform = "scale(1.2, 1.2)";
            } else {
                this.background.style.transition = "background 6s ease-out";
                this.background.style.backgroundSize = "auto 120%";   
            }
        }
    }

    private backgroundZoomOut() {
        if(this.background) {
            if(this.portrait) {
                this.background.style.transition = "transform 0.5s ease-out";
                this.background.style.transform = "scale(1, 1)";
            } else {
                this.background.style.transition = "background 0.5s ease-out";
                this.background.style.backgroundSize = "auto 100%";
            }
        }
        setTimeout(() => this.removeTransitions(), 600);
    }

    private removeTransitions() {
        if(this.background) {
            this.background.style.removeProperty("transition");
            if(this.portrait) {
                this.background.style.transform = "scale(1, 1)";
            } else {
                this.background.style.backgroundSize = "auto 100%";
            }
            this.background = null;
        }
    }

    private resetReels = () => {
        for(let i = 0; i < 5; i++) {
            this.reels[i] = false;
        }
        this.backgroundMotion = false;
    }

    private anticipate(reel: number) {
        if(reel >= 3 && reel <= 5) {
            Layers.MatrixBackground.getSprite("reel_highlight_" + reel).visible = true;
            const streakA = Layers.Custom.get("Anticipation").getAnimatedSprite(`streak${reel}a`);
            const streakB = Layers.Custom.get("Anticipation").getAnimatedSprite(`streak${reel}b`);
            streakA.visible = true; streakA.loop = true;
            streakB.visible = true; streakB.loop = true;
            streakA.gotoAndPlay(6);
            streakB.gotoAndPlay(0);
            this.clean();
            if(!this.backgroundMotion) {
                this.backgroundZoomIn();
                this.backgroundMotion = true;
                this.shakeTween = ShakeLayers([Layers.MatrixBackground, Layers.MatrixContent, Layers.MatrixForeground, Layers.SymbolAnimations, Layers.Custom.get("StackAddForeground"),
                        Layers.Footer, Layers.Custom.get("Animations")], 50, 10, 6, 40);
            } else {
                this.shakeTween = ShakeLayers([Layers.MatrixBackground, Layers.MatrixContent, Layers.MatrixForeground, Layers.SymbolAnimations, Layers.Custom.get("StackAddForeground"),
                        Layers.Footer, Layers.Custom.get("Animations")], 50, 1 + Math.random() * 6, 1 + Math.random() * 4, 30);
            }
        }
    }

    private stop(reel: number) {
        if(reel >= 3 && reel <= 5) {
            Layers.MatrixBackground.getSprite("reel_highlight_" + reel).visible = false;
            const streakA = Layers.Custom.get("Anticipation").getAnimatedSprite(`streak${reel}a`);
            const streakB = Layers.Custom.get("Anticipation").getAnimatedSprite(`streak${reel}b`);
            streakA.visible = false;
            streakB.visible = false;
            streakA.stop();
            streakB.stop();
        }
        if(reel == 5 && this.backgroundMotion) {
            this.backgroundZoomOut();
            this.clean();
        }
    }

    private hide() {
        for(let index = 3; index <= 5; index++) {
            Layers.MatrixBackground.getSprite("reel_highlight_" + index).visible = false;
        }
    }

    private clean() {
        if(this.shakeTween) {
            this.shakeTween.stop();
            TweenJS.remove(this.shakeTween);
            this.shakeTween = null;
        }
    }

}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/components/matrix/anticipation-component.ts